import app from 'flarum/forum/app';
const MAX_DESCRIPTION_LENGTH = 220;
function absoluteUrl(value) {
  if (!value) return '';
  return new URL(value, app.forum.attribute('baseUrl')).toString();
}
export default function shareData(post) {
  const discussion = post.discussion();
  const fallbackText = (post.contentPlain() || '').replace(/\s+/g, ' ').trim();
  const description = (discussion.contentExcerpt() || fallbackText).slice(0, MAX_DESCRIPTION_LENGTH);

  // Одна структура используется всеми сетями: заголовок, канонический URL, первый абзац
  // и редакционная обложка никогда не расходятся между соседними кнопками.
  return {
    title: discussion.title(),
    url: absoluteUrl(app.route.discussion(discussion)),
    description,
    image: absoluteUrl(discussion.coverUrl() || app.forum.attribute('devconnectSocialImage') || '/assets/devconnect-social.png')
  };
}
flarum.reg.add('devconnect-articles', 'forum/service/shareData', shareData);